import type { GetDocumentsQueryParams } from '@izimi/api';

export type DocumentsQueryKeyType =
  | 'documentNameMatch'
  | 'userDocuments'
  | 'vaultList'
  | 'trashList'
  | 'sharedToYouList'
  | 'sharedByYouList'
  | 'sharedFromNotaryList'
  | 'inheritedList'
  | 'nabanList'
  | 'selectDocuments'
  | 'notaryFilters'
  | 'scanning'
  | 'unSeen'
  | 'searchDocuments'
  | 'vaultTransfer'
  | 'preview';

class DocumentsQueryKeys {
  constructor(private prefix: string) {}

  getDocuments(type: DocumentsQueryKeyType, params?: GetDocumentsQueryParams) {
    if (params) {
      return [this.prefix, type, params];
    }
    return [this.prefix, type];
  }

  getDocument(documentId: string) {
    return [this.prefix, 'id', documentId];
  }

  downloadDocument(documentId: string) {
    return [this.prefix, 'download', documentId];
  }

  getLabels() {
    return [this.prefix, 'labels'];
  }

  getFilters() {
    return [this.prefix, 'filters'];
  }
}

export default DocumentsQueryKeys;
